import React from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ModuleDisplayEmail from "../../../../UI/modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayFieldsController from "../../../../UI/modules/fieldsDisplay/ModuleDisplayFieldsController";
import ModuleDisplayPhone from "../../../../UI/modules/fieldsDisplay/ModuleDisplayPhone";
import memberDummyImage from "../../../../../images/memberDummyImage.jpg";
import memberStatusEmailVerificationRequired from "../../../../../images/memberStatusEmailVerificationRequired.png";
import memberStatusSignupRequest from "../../../../../images/memberStatusSignupRequest.png";
import memberStatusRejected from "../../../../../images/memberStatusRejected.png";
import memberStatusRegistrationPaymentPending from "../../../../../images/memberStatusRegistrationPaymentPending.png";
import memberStatusMember from "../../../../../images/memberStatusMember.jpg";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayBoolean from "../../../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";

import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayRichText from "../../../../UI/modules/fieldsDisplay/ModuleDisplayRichText";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import ReactFancyBox from "react-fancybox";
import partnerDummyImage from "../../../../../images/partnerDummyImage.jpg";

var serverUploadsUrl = process.env.REACT_APP_BACKEND_URL + "public/";
const Details = ({
  item,
  moduleConfig,
  confirmAndDelete,
  confirmAndBlock,
  confirmAndUnblock,
  customButtonsForItems,
}) => {
  const getItems = () => {
    let items = [];
    if (item.website) {
      items = [...items, { text: "Website", value: item.website, type: "link" }];
    }
    if (item.websiteButtonText ) {
      items = [...items, { text: "Website Button Text", value: item.websiteButtonText , type: "text" }];
    }
    if (item.phone) {
      items = [...items, { text: "Phone", value: item.phone, type: "phone" }];
    }
    if (item.email) {
      items = [...items, { text: "Email", value: item.email, type: "email" }];
    }
    if (item.contactUsMessage) {
      items = [...items, { text: "Contact Message", value: item.contactUsMessage, type: "text" }];
    }
    if (item.promotionMessage) {
      items = [...items, { text: "Promotion Message", value: item.promotionMessage, type: "text" }];
    }
    return items;
  };
  return (
    <>
      <Row>
        <Col>
          <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 ">
                <div className="d-flex ImageSectionSpacing">
                  <div className="position-relative ms-1 me-2">
                    <div className="ms-1 me-2 position-relative">




                      <>
                        {item.logo ? (
                          // <Image
                          //   src={
                          //     process.env.REACT_APP_BACKEND_URL + "public/" + item.logo
                          //   }
                          //   width="52px"
                          //   height="52px"
                          //   className="border rounded-circle image-contain"
                          // />
                          <div className="logo-small border rounded-circle image-contain">
                            <ReactFancyBox
                              thumbnail={process.env.REACT_APP_BACKEND_URL + "public/" + item.logo}
                              image={process.env.REACT_APP_BACKEND_URL + "public/" + item.logo}
                            />
                          </div>
                        ) : (
                          <Image
                            src={partnerDummyImage}
                            width="52px"
                            height="52px"
                            className="border rounded-circle image-contain"
                          />
                        )}
                      </>

                      {item.status === "0" && (
                        <i className="fas fa-ban position-absolute banned2"> </i>
                      )}
                    </div>
                  </div>

                  <div className="d-flex align-items-center ms-1">
                    <span className="m-0 text-bold memberName">
                      {item.title}
                    </span>


                  </div>
                </div>
              </Card.Title>

              <div className="card-tools">
                <div className=" text-right mt-xl-0 mt-1">
                  {item.isPromoted === "1" &&
                    <span className="badge badge-info me-1 pt-0">
                      Promoted
                    </span>}
                  <span className="badge badge-light me-1 text-dark">
                    Status :{" "}
                    <span class="text-secondary">
                      <ModuleDisplayBoolean
                        value={item.status}
                        trueValue="Enabled"
                        falseValue="Disabled"
                      />{" "}
                    </span>
                  </span>

                  <span class="badge badge-light me-1 text-dark">
                    Created Date/Time :{" "}
                    <span class="text-secondary">
                      <ModuleDisplayDate value={item.createdAt} />{" "}
                    </span>
                  </span>
                </div>
              </div>
            </Card.Header>

            <Card.Body className="p-2">
              <StatsListing items={getItems()} />
              <Row>



                {item.promotionBanner && (
                  <Col lg={2} xl={2} md={2}>
                    <Card className="align-items-center d-flex pt-2 mb-3 pb-0  px-3 justify-content-center">
                      <div className="registrationCard">
                        <ReactFancyBox
                          thumbnail={`${serverUploadsUrl}${item.promotionBanner}`}
                          image={`${serverUploadsUrl}${item.promotionBanner}`}
                        />
                      </div>
                      <Card.Body className="p-0">
                        Promotion Banner
                      </Card.Body>
                    </Card>
                  </Col>
                )}
                {item.banner && (
                  <Col lg={2} xl={2} md={2}>
                    <Card className="align-items-center d-flex pt-2 mb-3 pb-0  px-3 justify-content-center">
                      <div className="registrationCard">
                        <ReactFancyBox
                          thumbnail={`${serverUploadsUrl}${item.banner}`}
                          image={`${serverUploadsUrl}${item.banner}`}
                        />
                      </div>
                      <Card.Body className="p-0">
                        Banner
                      </Card.Body>
                    </Card>
                  </Col>
                )}
              </Row>
              {item.heading1 && (
                <div class="font-weight-bold fs-5 cutsomText-red ms-2">
                  {item.heading1}
                </div>
              )}

              {item.content1 && (
                <div class="me-1  mb-1 p-2 ">
                  <ModuleDisplayRichText value={item.content1} />
                </div>
              )}


              {item.heading2 && (
                <div class="font-weight-bold fs-5 cutsomText-red ms-2">
                  {item.heading2}
                </div>
              )}

              {item.content2 && (
                <div class="me-1  mb-1 p-2 ">
                  <ModuleDisplayRichText value={item.content2} />
                </div>
              )}


              {item.heading3 && (
                <div class="font-weight-bold fs-5 cutsomText-red ms-2">
                  {item.heading3}
                </div>
              )}

              {item.content3 && (
                <div class="me-1  mb-1 p-2 ">
                  <ModuleDisplayRichText value={item.content3} />
                </div>
              )}



              {item.heading4 && (
                <div class="font-weight-bold fs-5 cutsomText-red ms-2">
                  {item.heading4}
                </div>
              )}

              {item.content4 && (
                <div class="me-1  mb-1 p-2 ">
                  <ModuleDisplayRichText value={item.content4} />
                </div>
              )}



              {item.heading5 && (
                <div class="font-weight-bold fs-5 cutsomText-red ms-2">
                  {item.heading5}
                </div>
              )}

              {item.content5 && (
                <div class="me-1  mb-1 p-2 ">
                  <ModuleDisplayRichText value={item.content5} />
                </div>
              )}

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Details;
